<template>
  <div class="main">
    <tab title="车卡列表"></tab>
    <div class="select_box">
      <van-search
        v-model="value"
        placeholder="请输入车牌号码搜索"
        input-align="center"
        @input="getCarCardList"
      />
    </div>
    <div class="card_list" v-if="list.length>0">
      <div v-for="item in list" v-bind:key="item.id" class="card" @click="toDetail(item)">
        <div class="cardNo">卡号：{{item.cardNo}}</div>
        <div class="oli">持卡人：{{item.orgName}}</div>
        <div class="oli">车牌号码：{{item.carNo}}</div>
        <div class="oli">余额：{{item.balance}}</div>
        <div class="oli">状态：<span :class="item.status==1?'lv':'red'">{{item.status==1?'启用':'禁用'}}</span></div>
        <div class="btn_box">
          <div class="info_btn" @click="toDetail(item)">操作</div>
        </div>
      </div>
      <!-- <div class="card">
        <div class="cardNo">卡号：700001</div>
        <div class="oli">持卡人：张三</div>
        <div class="oli">余额：300.00</div>
        <div class="oli">状态：<span class="red">禁用</span></div>
        <div class="btn_box">
          <div class="operation_btn" @click="determineType(0)" id="lv">
            启用
          </div>
          <div class="info_btn" @click="toDetail(1)">操作</div>
        </div>
      </div> -->
    </div>
    <div class="none" v-if="list.length<=0">
          <img src="../../static/img/wujilu_img.png" alt="">
          暂无车卡
      </div>
  </div>
</template>

<script>
import tab from "@/components/NavBar";
import Vue from "vue";
import { Search } from "vant";
import { Button } from "vant";
import { Dialog } from "vant";
import { Toast } from 'vant';

Vue.use(Button);
Vue.use(Toast);
Vue.use(Search);
export default {
  name: "margin",
  data() {
    return {
      value: "",
      list: [],
    };
  },
  components: {
    tab,
  },
  mounted() {
    this.getCarCardList("");
  },
  methods: {
    getCarCardList(value) {
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      if (value - 0 > 1) {
        var data = {
          cardNo: value,
        };
      } else {
        var data = {
          carNo: value,
        };
      }
      data.token = this.$storage.get('token')
      this.$api.post('orgapp/getCarCardList',data,response=>{
          if (response.status >= 200 && response.status < 300) {
              console.log(response.data)
              var data = response.data
              Toast.clear();
              if(data.msg == 'success'){
                var list = response.data.list;
                list.forEach(element => {
                    element.balance = (element.balance/100).toFixed(2)
                    element.perAmount = (element.perAmount/100).toFixed(2)
                });
                this.list = list
              }
          }else{
              Toast.clear();
              Toast.fail(response.status);
          }
      })
    },
    toDetail(item) {
      console.log(item);
      this.$router.push({
        name: "jiayou_operation",
        // query: { ykid: id, nav_name: "车卡操作" },
        params: { item:item, nav_name: "车卡操作" },
      });
    },
    determineType(type,id) {
      if (type == 1) {
        //当前状态为启用，点击后执行停用
        //调用接口停用
        var msg = "确认禁用该加油卡？";
        var status = 0
      }
      if (type == 0) {
        //当前状态为停用，点击后执行启用
        //调用接口启用
        var msg = "确认启用该加油卡？";
        var status = 1
      }
      Dialog.confirm({
        title: "标题",
        message: msg,
      })
        .then(() => {
          // on confirm
          this.enableCarCard(id,status)
        })
        .catch(() => {
          // on cancel
        });
    },
    enableCarCard(id,status){
        var data = {
            id:id,
            status:status,
            token:this.$storage.get('token')
        }
        this.$api.post('orgapp/enableCarCard',data,response=>{
            if (response.status >= 200 && response.status < 300) {
                console.log(response.data);
                var data = response.data;
                if(data.msg=='success'){
                    Toast.success('更改成功！');
                    this.value =''
                    this.getCarCardList('')
                }
            }
        })
    }

  },
};
</script>

<style scoped>
.main {
  background-color: #f7f8fa;
  height: 100vh;
}
.select_box {
  width: 100%;
  background-color: #fff;
  text-align: center;
}
.card_list {
  width: 93%;
  margin: auto;
}
.card {
  margin-top: 10px;
  width: 100%;
  height: 97px;
  background-color: #fff;
  position: relative;
  color: #000;
  border-radius: 6px;
  font-family: 'SimSun';
}
.cardNo {
  border-bottom: 1px solid #eee;
  height: 30px;
  line-height: 30px;
  padding-left: 10px;
  font-size: 14px;
}
.oli {
  padding-left: 10px;
  height: 25px;
  width: 36%;
  line-height: 25px;
  display: inline-block;
}
.lv {
  color: chartreuse;
}
.red {
  color: #fb0606;
}
.btn_box {
  position: absolute;
  right: 0;
  bottom: 5px;
}
.operation_btn {
  width: 62px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  background-color: #ee0a24;
  display: inline-block;
  margin-right: 5px;
}
.info_btn {
  width: 62px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  border-radius: 4px;
  background-color: #1989fa;
  display: inline-block;
  margin-right: 5px;
  color: #fff;
}
.none {
    width: 100px;
    height: 100px;
    margin: auto;
    margin-top: 30px;
    text-align: center;
    font-size: 20px;
}
.none img {
    width: 100%;
    height: 100%;
}
#lv {
  background-color: #07c160;
}
</style>



// WEBPACK FOOTER //
// src/components/cardList.vue